import { autoinject, transient, useView } from "aurelia-framework";
import { BaseOnboardingStepModel } from "../base-step-model";
import { OnboardingSession } from "../../onboarding.session";
import { OnboardingClientService } from "../../../../../services/onboarding/onboarding-client.service";

@autoinject()
@transient()
@useView('views/pages/onboarding-client/steps/invalid-country/invalid-country.html')
export class InvalidCountry extends BaseOnboardingStepModel {
    
    protected _canShow: boolean = true;
    protected _canGoBack: boolean = false;

    public country: string = null;

    constructor(onboardingClientService: OnboardingClientService,
        onboardingSession: OnboardingSession) {
        super(onboardingClientService, onboardingSession);
    }
}
